import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ComponentContextProvider } from "./contexts/component-context";
import { PermissionContextProvider } from "./contexts/permission-context";
import PrivateRoute from './Utils/PrivateRoute';
import Login from "./components/Login/Login";
import Main from "./components/Main/Main";
import Missing from "./pages/Missing";

function App() {
  return (
    <div id="app" className="App">
      <PermissionContextProvider>
        <ComponentContextProvider>

          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/test" element={<Main />} />
              <Route
                path="main"
                element={
                  <PrivateRoute>
                    <Main />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Missing />} />
            </Routes>
          </Router>

        </ComponentContextProvider>
      </PermissionContextProvider>
    </div>
  );
}

export default App;
